import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isUIService} from '@github-ui/runtime-environment'

/** Whether the React code-view sidebar is active (always true in UI service, feature-flagged elsewhere). */
export function isReactCodeViewSidebarEnabled(): boolean {
  return isUIService || isFeatureEnabled('react_data_router_code_view_sidebar')
}

/**
 * When true, sidebar wrappers share a single `useSuspenseQuery` against the combined
 * route instead of issuing one HTTP request per section.
 */
export function isCombinedSidebarPayloadEnabled(): boolean {
  return isFeatureEnabled('codeview_sidebar_combined_payload')
}
